import { TestAdapter } from '@oracle/oraclejet-testing/UNSAFE_TestAdapter';

export class ButtonAdapter extends TestAdapter {
  /**
   * Click on the button
   * @returns
   */
  async doAction(): Promise<void> {
    return this.getTestDriver().click(await this.getElement());
  }
}
